import type {InputHTMLAttributes, ReactNode} from "react";

interface BaseInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  prefix?: ReactNode;
  suffix?: ReactNode;
}

export const BaseInput = ({label, error, helperText, prefix, suffix, id, className = "", ...rest}: BaseInputProps) => {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label
          htmlFor={inputId}
          className="text-sm font-medium text-(--color-text)"
        >
          {label}
        </label>
      )}

      <div className="relative flex items-center">
        {prefix && <span className="absolute left-3 text-(--color-text-tertiary) pointer-events-none">{prefix}</span>}

        <input
          id={inputId}
          className={[
            "w-full bg-white border rounded-md py-2 text-sm text-(--color-text) placeholder:text-(--color-text-tertiary)",
            "outline-none transition-[border-color,box-shadow] duration-(--transition-fast)",
            "focus:border-(--color-accent) focus:ring-2 focus:ring-(--color-accent) focus:ring-opacity-20",
            error
              ? "border-(--color-danger) focus:border-(--color-danger) focus:ring-(--color-danger)"
              : "border-(--color-border)",
            prefix ? "pl-9" : "pl-3",
            suffix ? "pr-9" : "pr-3",
            rest.disabled ? "bg-(--color-surface-2) cursor-not-allowed text-(--color-text-secondary)" : "",
            className,
          ].join(" ")}
          {...rest}
        />

        {suffix && <span className="absolute right-3 text-(--color-text-tertiary)">{suffix}</span>}
      </div>

      {error && <p className="text-xs text-(--color-danger)">{error}</p>}
      {!error && helperText && <p className="text-xs text-(--color-text-tertiary)">{helperText}</p>}
    </div>
  );
};
